import React, { FC, useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { RuleSet } from 'styled-components'

import { fetchSharingUrlListAction } from 'actions/sharingContent/fetchSharingUrlListAction'
import { shareHitMethodStatisticsAction } from 'actions/sharingContent/shareHitMethodStatisticsAction'
import { fetchUniNoticeAction } from 'actions/uninotice/uniNoticeAction'
import { useShallowEqualSelector } from 'common/hooks/useShallowEqualSelector'
import { VoidHandler } from 'common/types'
import { DefaultLoader } from 'components/presentational/AnimatedWatch/AnimatedWatch'
import { sharingUrlCopiedId } from 'components/uninotice/uniNoticeIdList'
import { useRedesignLayout } from 'hooks/useRedesign'
import { useReducersInsert } from 'hooks/useReducersInsert'
import { sharingContentReducer } from 'reducers/sharingContentReducer'

import { SharingType } from './SharingContent.constant'
import { SharingContentNextView } from './SharingContentNextView'
import { SharingContentView } from './SharingContentView'

export const SharingContent: FC<{
  type: SharingType
  contentId: number
  profileId: number
  hasNewDesign?: boolean
  alignmentStyleCss?: RuleSet<object>
  callbackHandler?: VoidHandler
}> = ({
  type,
  contentId,
  profileId,
  alignmentStyleCss,
  hasNewDesign = false,
  callbackHandler,
}) => {
  useReducersInsert({ sharingContent: sharingContentReducer })
  const dispatch = useDispatch()
  const redesignLayout = useRedesignLayout()
  const { sharingMethods, contentIdCurrent } = useShallowEqualSelector(
    ({ sharingContent: { sharingMethods, contentId: contentIdCurrent } }) => ({
      sharingMethods,
      contentIdCurrent,
    })
  )

  const handleFetchUniNotice = () => {
    dispatch(fetchUniNoticeAction(sharingUrlCopiedId))
  }

  const handleShareHitMethod = (sharingMethod: string) => {
    dispatch(
      shareHitMethodStatisticsAction(type, contentId, profileId, sharingMethod)
    )
  }

  useEffect(() => {
    if (contentIdCurrent !== contentId) {
      dispatch(fetchSharingUrlListAction(type, contentId, profileId))
    }
  }, [contentId, dispatch, type, profileId, contentIdCurrent])

  if (sharingMethods.length === 0) {
    return <DefaultLoader />
  }

  if (redesignLayout && hasNewDesign) {
    return (
      <SharingContentNextView
        sharingMethods={sharingMethods}
        fetchUniNoticeAction={handleFetchUniNotice}
        shareHitMethodStatisticsAction={handleShareHitMethod}
        callbackHandler={callbackHandler}
      />
    )
  }

  return (
    <SharingContentView
      alignmentStyleCss={alignmentStyleCss}
      sharingMethods={sharingMethods}
      fetchUniNoticeAction={handleFetchUniNotice}
      shareHitMethodStatisticsAction={handleShareHitMethod}
    />
  )
}
